export default "__VITE_ASSET__UtvdIr4H__";